import { render, staticRenderFns } from "./UploadFileDetailsForm.vue?vue&type=template&id=4852549e"
import script from "./UploadFileDetailsForm.vue?vue&type=script&lang=js"
export * from "./UploadFileDetailsForm.vue?vue&type=script&lang=js"
import style0 from "./UploadFileDetailsForm.vue?vue&type=style&index=0&id=4852549e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports